import type { SelectedItemRenderProps } from '@openx/components-core/lib/SelectionDrawer/types.ts';
import { SelectedContextualSegmentItem, type SelectedSegmentWithMode } from './SelectedContextualSegmentItem.tsx';

export const SelectedContextualSegmentItemDisplay = (props: SelectedItemRenderProps<SelectedSegmentWithMode>) => (
  <SelectedContextualSegmentItem {...props} wrapText hideRemoveUntilHover />
);
